import React from 'react';
import PropTypes from 'prop-types';
/* Styles */
import './empty-widget-content.scss';

export default class WidgetEmpty extends React.PureComponent {
  render() {
    return (
      <div
        className="glu-content__section glu-content__separator glu-content__separator--inner glu-spread-v"
        data-testid={this.props.dataTestId}
      >
        <div className="glu-widget-empty">
          <span className="g-icon g-icon-info" />
          <div className="glu-h6 text-bold">{this.props.text}</div>
          {this.props.isEditAllowed && (
            <div className="glu-flex-shrink">
              <div className="glu-pill glu-pill--generic" onClick={this.props.showSettingsModal}>
                Configure
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

WidgetEmpty.propTypes = {
  showSettingsModal: PropTypes.func,
  isEditAllowed: PropTypes.bool,
  text: PropTypes.string,
};

WidgetEmpty.defaultProps = {
  showSettingsModal: undefined,
  isEditAllowed: false,
  text: 'The initial widget configuration is empty',
};
